import { ValeurFichierSelectors } from '@get/store/selectors';
import { SelectorModel } from '@get/utils';

// tslint:disable-next-line: variable-name
export const ValeurFichierModel: SelectorModel = {
  name: 'valeurFichiers',
  getSelector: ValeurFichierSelectors.selectAllValeurFichiersDictionary,
  isReady: ValeurFichierSelectors.selectIsReadyValeurFichier
};
